import { mapState, mapGetters } from 'vuex';
export default {
  name: 'ViewAlarmLogsList',
  props: {},
  data() {
    return {
      selectedAccountIds: [],
      accountFilterReady: false
    };
  },
  computed: {
    ...mapState('app', ['color']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    })
  },
  methods: {
    accountSelectionChanged(accounts) {
      this.selectedAccountIds = accounts.map(account => account.id);
    }
  }
};